import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20composition%20of%20curated%20fashion%20and%20lifestyle%20products%20on%20a%20light%20cream%20linen%20surface%2C%20featuring%20designer%20sneakers%20with%20premium%20leather%20texture%2C%20a%20folded%20cashmere%20sweater%20in%20warm%20oatmeal%20tone%2C%20leather%20tote%20bag%20with%20brass%20hardware%2C%20minimalist%20sunglasses%2C%20a%20ceramic%20coffee%20cup%2C%20and%20dried%20pampas%20grass%20in%20a%20glass%20vase%2C%20bathed%20in%20soft%20morning%20sunlight%20from%20a%20large%20window%2C%20gentle%20natural%20shadows%2C%20editorial%20product%20photography%20style%2C%20airy%20and%20fresh%20aesthetic%2C%20warm%20neutral%20palette%20with%20muted%20earth%20tones%2C%20high%20end%20boutique%20catalog%20feel&width=1600&height=900&seq=superbuy-hero-v2-2026&orientation=landscape"
        alt="Superbuy Spreadsheet - Curated fashion and lifestyle product discovery platform"
        title="Superbuy Spreadsheet Product Discovery"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide" style={{ fontFamily: 'var(--font-label)' }}>
            Updated 2026 &middot; 14 Product Categories
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          Superbuy Spreadsheet
          <br />
          <span className="text-accent-300 italic font-normal">Your Ultimate Product Discovery Hub</span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
          Browse thousands of organized product resources across 14 categories. From sneakers to accessories,
          discover curated Superbuy Spreadsheet collections designed to help you shop smarter and faster.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            style={{ fontFamily: 'var(--font-label)' }}
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Superbuy Sheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-white/20 backdrop-blur-sm border border-white/30 text-white rounded-full font-semibold text-base hover:bg-white/30 transition-all duration-300 cursor-pointer"
            style={{ fontFamily: 'var(--font-label)' }}
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/70 text-sm" style={{ fontFamily: 'var(--font-body)' }}>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i> Updated Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i> Organized Categories
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i> Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i> Independent Research Platform
          </span>
        </div>

        <div className="mt-14">
          <a href="#categories" className="inline-flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors duration-300 cursor-pointer">
            <span className="text-xs tracking-wide" style={{ fontFamily: 'var(--font-label)' }}>Explore Categories</span>
            <i className="ri-arrow-down-s-line text-xl animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}